import $ from 'jquery';
import async from 'async';

angular.module("SupportAgent")
.controller(
 'LoginController',
 function ($scope, EventHandler, $location, $rootScope,$timeout,$routeParams,L,INTRACTABLE,INTERACT) {

  $scope.rememberme = false;
  $scope.activated = $routeParams.activated||undefined;
  $scope.session={};

  if($routeParams.token) (function() {
   var pp = { token: $routeParams.token };
   if($routeParams.domainname) pp.domainname = $routeParams.domainname;
   if($routeParams.username) pp.username = $routeParams.username;
   // TODO: visual feedback during the call
   INTRACTABLE.request('user/confirm',pp,function(e,r) {
    if(e) {
     L.error({err:e},"error confirming account");
     // TODO: make it known
    }else if(r._S!='ok') {
     L.error({r:r},"error confirming account");
     // TODO: make it known
    }else{
     $scope.activated = true;
     // TODO: maybe only when the fields haven't been touched?
     if(pp.username) $scope.session.username = pp.username;
     if(pp.domainname) $scope.session.domain = pp.domainname;
    }
   });
  })();

  //Method to interface UI with EventHandler Service
  var THAT=this;
  $scope.isValidForm=function() {
   let login=THAT.loginForm.username.$valid&&THAT.loginForm.password.$valid;
   if(!$rootScope.is_dynamic_domain_portal) return login;
   return login&&THAT.loginForm.domain.$valid;
  };
  $scope.login = function login(username, password,domain) {
   L.trace({username,password,domain},"going to login from login controller…");
   $scope.login_error_message="";
   if(!navigator.onLine) {
    $scope.login_error_message=$rootScope.strings.str_check_internet_connection;
    return;
   }
   $('#btn_login_submit').button('loading'); // TODO: don't do that via elements manipulations
   async.auto({
    login: function login(cb) {
     INTERACT.U.login({
      domain: domain||+WTGCONFIG.domain,
      username:username, password: password
     },cb);
    },
    verify: ['login',function(r,cb){
     if(!$rootScope.is_dynamic_domain_portal) return cb(null, true);
     INTRACTABLE.request('user/verify',{},function(e,r) {
      if(e) return cb(e);
      cb(null, r.valid);
     });
    }],
    logout: ['verify',function(r,cb){
     if(!$rootScope.is_dynamic_domain_portal) return cb();
     if(!r.verify) EventHandler.APILAYER.logout();
     cb();
    }]
   },function(e,r){
    $('#btn_login_submit').button('reset');
    if(e) {
     L.error({err:e,r:r},"error trying to login and/or verify user");
     $scope.login_error_message = (e.api=="domain"&&e.r._S=="notfound")?$rootScope.strings.str_non_registered_organization:
     (e.reason=="timeout")?$rootScope.strings.str_login_timeout_info:$rootScope.strings.str_login_failed;
    }
    else if(!r.verify)
     $scope.login_error_message = WTG.fmt($rootScope.strings.str_account_activation_error,{destination:username});
    else {
     if($scope.rememberme) $rootScope.persist_login();
     $location.path('/');
    }
   });
  };
 });
